import type { ChatSessionType } from '@demind-inc/core';

export interface SlashCommandShortcut {
  command: string;
  prompt?: string;
  prefillText?: string;
  planType?: ChatSessionType | 'freeText';
  isCustom?: boolean;
}

export const slashCommandShortcuts: SlashCommandShortcut[] = [
  {
    command: '/plan-my-day',
    planType: 'scheduler',
    prompt: '📅 Plan my entire day',
  },
  {
    command: '/plan-my-week',
    planType: 'scheduler',
    prompt: '📅 Plan my week',
  },
  {
    command: '/plan-my-tasks',
    planType: 'task',
    prompt: 'Plan my tasks today',
  },
  {
    command: '/plan-my-meal',
    planType: 'meal',
    prompt: 'Plan my meal today',
  },
  {
    command: '/plan-my-sleep',
    planType: 'sleep',
    prompt: 'Plan my sleep today',
  },
  {
    command: '/plan-my-workout',
    prompt: 'Plan my workout today',
  },
  {
    command: '/tell-me-what-to-do',
    prompt: 'Tell me about what to do now',
  },
  {
    command: '/tell-me-tasks',
    prompt: 'Tell me about my tasks today',
  },
  {
    command: '/tell-me-schedule',
    prompt: 'Tell me about my schedule today',
  },
  {
    command: '/tell-me-sleep',
    prompt: 'Tell me about my sleep last night',
  },
  {
    command: '/tell-me-energy',
    prompt: 'Tell me about my energy today',
  },
  {
    command: '/focus-time',
    prompt: 'Block focus time',
  },
  {
    command: '/decompress',
    prompt: 'Add time to decompress after my meetings',
  },
  {
    command: '/recharge',
    prompt: 'Add events to recharge and recover',
  },
  {
    command: '/break-down-tasks',
    prompt: 'Break down my tasks into smaller ones and create them',
  },
  {
    command: '/rate-schedule',
    prompt: 'Rate my schedule today',
  },
  {
    command: '/meeting-prep',
    prompt: 'What should I do to prepare for my next meeting',
  },
];
